import type { ColumnMapping } from "./types";
import type { MeasurementCreateInput } from "@globals";

export function getExperimentMeasurementsFromMapping(mappings: ColumnMapping[]): MeasurementCreateInput[] {
  return mappings
    .filter(item => !item.disabled && item.type === "measurement")
    .map(item => ({
      id: item.id,
      name: item.column_name
    }));
}
